import { cn } from '@/utils/cn'

export type BadgeVariant = 'success' | 'danger' | 'warning' | 'info' | 'default' | 'muted'

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
  children: React.ReactNode
}

const variantStyles: Record<BadgeVariant, string> = {
  success: 'bg-[rgba(39,166,68,0.15)] text-[#27a644] border-[rgba(39,166,68,0.2)]',
  danger:  'bg-[rgba(229,72,77,0.15)] text-[#e5484d] border-[rgba(229,72,77,0.2)]',
  warning: 'bg-[rgba(245,166,35,0.15)] text-[#f5a623] border-[rgba(245,166,35,0.2)]',
  info:    'bg-[rgba(59,130,246,0.15)] text-[#3b82f6] border-[rgba(59,130,246,0.2)]',
  default: 'bg-[var(--brand-primary-muted)] text-[var(--brand-primary)] border-[rgba(94,106,210,0.2)]',
  muted:   'bg-[var(--glass-bg)] text-[var(--text-muted)] border-[var(--glass-border)]',
}

export function Badge({ variant = 'default', children, className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full border font-medium',
        'text-[11px] leading-none whitespace-nowrap',
        variantStyles[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}

// Mapeamento de status para variante
export function getStatusVariant(status: string): BadgeVariant {
  const map: Record<string, BadgeVariant> = {
    // Lead status
    novo: 'info',
    follow_up: 'warning',
    atrasado: 'danger',
    nutricao: 'muted',
    handoff: 'default',
    perdido: 'danger',
    // Deal stage
    qualificado: 'info',
    reuniao_agendada: 'info',
    reuniao_realizada: 'info',
    proposta_elaboracao: 'warning',
    proposta_enviada: 'warning',
    teste_gratis: 'info',
    renegociacao: 'warning',
    ajustar_proposta: 'warning',
    gerar_contrato: 'default',
    contrato_enviado: 'default',
    ganho: 'success',
    pausado: 'muted',
    fechamento_futuro: 'info',
    // Company status (API + legado)
    CLIENTE_ATIVO: 'success',
    PROSPECT: 'info',
    CHURN: 'danger',
    ativo: 'success',
    inativo: 'muted',
    prospecto: 'info',
    churned: 'danger',
    // Commission status
    pendente: 'warning',
    aprovado: 'info',
    pago: 'success',
    estornado: 'danger',
    cancelado: 'danger',
    // Health score
    verde: 'success',
    amarelo: 'warning',
    vermelho: 'danger',
  }
  return map[status] ?? 'muted'
}
